import type { Theme } from "@mui/material/styles";
import type { AppDataPrepPageStyles } from "../types";

export function buildDataPrepPageStyles(_theme: Theme): AppDataPrepPageStyles {
  return {
    designAlertMaxWidth: { maxWidth: 420 },
    prepJobRunsClickableRow: (clickable: boolean) => ({
      cursor: clickable ? "pointer" : "default",
      "&:hover": clickable ? { bgcolor: "action.hover" } : undefined,
    }),
  };
}
